import axios from "axios";
import i18n from "../i18n";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function apiError(e) {
  // nginx rejects an oversized body before the API ever sees it, so there is no
  // JSON detail to read — only an HTML error page. Without this branch the
  // generic "something went wrong" hid the one fact the user could act on.
  if (e?.response?.status === 413) return i18n.t("common.file_too_large");
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Unexpected error";
}

export const BACKEND_URL = BACKEND;

// Un fichier que le navigateur télécharge lui-même : il lui faut une adresse,
// pas un appel axios.
export const apiUrl = (path) => `${BACKEND}/api${path}`;
